import { render, staticRenderFns } from "./PopToast.vue?vue&type=template&id=fafe6422&scoped=true"
import script from "./PopToast.vue?vue&type=script&lang=js"
export * from "./PopToast.vue?vue&type=script&lang=js"
import style0 from "./PopToast.vue?vue&type=style&index=0&id=fafe6422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe6422",
  null
  
)

export default component.exports